export default __webpack_public_path__ + "static/media/eye-close.19751719.svg";